<template>
  <div>

    <div class='titleRow'>
      <div class='circleYellow'></div>
      <!-- 关联租约 -->
      <div class='titleText'>{{ $t('customer.customerDetail.customerRelation') }}</div>
      <!--    <div class='right_icon'>-->
      <!--      <a-icon type='caret-up' />-->
      <!--      <a-icon type='caret-down' />-->
      <!--    </div>-->
    </div>
    <div id='relation_div' style="margin-bottom: 30px;"  >
      <pt-simple-table :data-source="dataList"  :total="dataList.length" :showSearch="false" :loading="false">
        <template slot="columns">
          <el-table-column :label="$t('customer.customerDetail.relationUser')"   show-overflow-tooltip>
            <template slot-scope="scope">
              <template>
                <a-avatar icon="user" :size="20" :src="getImageUrl(scope.row.headimg)"></a-avatar>
                <span style='font-size: 12px;'>{{scope.row.userName}}</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customer.customerDetail.customerRelation')" >
            <template slot-scope="scope">
              <div style='width: 500px'>
                <a-popover v-if='false' style='width: 500px'  placement="bottomLeft" trigger="hover" >
                  <template #content>
                    <a-timeline :reverse='true'  >
                      <a-timeline-item  v-for='(item,index) in scope.row.customerRelationChangeVOS ' :key=index :value='item' >
<!--                        <template #dot>-->
<!--                          <div class='circleYellow'></div>-->
<!--                        </template>-->
                        <div style='width: 150px'>
                          <pt-tag   :color="index ==scope.row.customerRelationChangeVOS.length-1?'default':'grey' " size="small"  >
                            {{item.relationTypeStr}}
                          </pt-tag>
                        </div>
                        <div class='context'>
                          {{$utils.format(item.createTime,'YYYY-MM-DD HH:mm')}}
                        </div>
                        <div class='context' v-if="item.reason!= '~'">
                          {{item.reason}}
                        </div>
                      </a-timeline-item>
                    </a-timeline>
                  </template>
                  <div> {{scope.row.customerRelationChangeVOS[scope.row.customerRelationChangeVOS.length-1].relationTypeStr}}</div>
                </a-popover>
                <div style='font-size: 12px'> {{scope.row.relationStr}}</div>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customer.customerList.relationLatestTime')"   show-overflow-tooltip>
            <template slot-scope="scope">
              <template>
                <span style='font-size: 12px;' v-if="scope.row.recordTime!='~'">{{$utils.formatDate(scope.row.recordTime)}}</span>
                <span style='font-size: 12px;' v-else>~</span>
              </template>
            </template>
          </el-table-column>
          <el-table-column :label="$t('customer.customerDetail.relationStatus')"   show-overflow-tooltip>
            <template slot-scope="scope">
              <template>
                <span style='font-size: 12px;'>{{$t('customer.customerDetail.relationStatus1.'+scope.row.allow)}}</span>
              </template>
            </template>
          </el-table-column>
        </template>
      </pt-simple-table>

    </div>
  </div>


</template>

<script>
import Api from '@/api/mine/customerRelation'
import customerRecordsApi from '@/api/mine/customerRecords'
import moment from 'moment'
import { getDatadictChildsByPath } from '@/api/sys/datadict'

export default {
  name: 'customerRelation',
  props: {
    customerVO: {
      type: Object
    }
  },

  data() {
    return {
      dataList: [],
      // records: []
    }
  },
  watch: {
    'customerVO.id'() {
      this.init()
    }
  },
  mounted() {
    if (this.customerVO.id) {
      this.init()
    }

  },
  methods: {
    init() {
      this.getData()
    },
    getImageUrl(headimg){
      return this.$util.getFileUrl(headimg)
    },
    getData() {
      console.log('---------customerVO', this.customerVO)
      Api.getAllRelationByCustomerId(this.customerVO.id).then(res => {
        if (res.code == 1) {
          this.dataList = res.data
          console.log("---------customerVO",res.data)
        }
      })
      // customerRecordsApi.selectRelationByBusinessIdAndDataNotNull(this.customerVO.id).then(res=>{
      //   if (res.code == 1) {
      //     this.dataList = res.data
      //     console.log("---------customerVO",res.data)
      //   }
      // })
    }
  }
}
</script>

<style scoped lang='less'>
.titleRow {
  background: #FAFBFC;
  height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  position: relative;
  margin-bottom: 5px;

  .circleYellow {
    width: 12px;
    height: 12px;
    background: #FABE00;
    border-radius: 50%;
    margin: 0 10px;
  }
  .context{
    font-family: PingFangTC-Semibold;
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
    text-align: justify;
    font-weight: 600;
  }

  .titleText {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
  }
  .ant-popover-inner-content{
    width: 360px;
  }
  .ant-timeline-item-head ant-timeline-item-head-blue{
    color: #D3D3D3;
    border-color: #D3D3D3;
    background-color: #D3D3D3;
    width: 15px;
    height: 15px;
  }
  .right_icon {
    cursor: pointer;
    position: absolute;
    right: 10px;
    color: #CACACA;
    font-size: 12px;
    width: 30px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
#relation_div{
  background: rgba(248,249,251,0.62);
  //border: none;
}
#relation_div /deep/ .pt-simple-table {
  background-color: transparent !important;

  .el-table, tr, td {
    background-color: transparent !important;
    border: none;
  }
  .el-table:before{
    height: 0px;
  }
}
</style>